
// export default interface ControllerProps {
//   data: ControllerData;
//   events?: ControllerEvents;
//   options?: ControllerOptions;
//   testId?: string;
// }

// export interface ControllerData {
//   caption: boolean;
//   chapteredVideoData: any;
//   currentTime: number;
//   fullScreen: boolean;
//   mute?: boolean;
//   playing: boolean;
//   totalTime: number;
//   transcript: boolean;
//   volume?: number;
//   showTranscript: boolean;
//   showCaption: boolean;
// }

// export interface ControllerOptions {
//   enlarge?: boolean;
//   className?: string;
//   showFullScreen?: boolean;
//   showCaption?: boolean;
//   showTranscript?: boolean;
// }

// export interface ControllerEvents {
//   handlePlayPause?(playPause: boolean): void;
//   captionClick?(showing: boolean): void;
//   fullScreenClick?(fullScreen: boolean): void;
//   transcriptClick?(showTranscript: boolean): void;
//   handleMute?(mute: boolean, volumn: number): void;
//   handleVolumeChange?(mute: boolean, volumn: number): void;
//   handleSeekVideo?(value: number): void;
// }

export enum Types {
  Box = 1,
  Wrapper,
  Button,
  Slider,
  Text,
}

export enum TooltipFormat {
  Timecode = 'Timecode',
}